import styled, { css } from 'styled-components';
import CardBackground from 'images/related-scenarios-background.png';

export const Wrapper = styled.a(
  ({ theme }) => css`
    margin: ${theme.sz.s0} ${theme.sz.s3} ${theme.sz.s5};
    border-radius: ${theme.sz.s3};
    text-decoration: none;

    &:hover {
      background: ${theme.co.neutral98};
    }

    @media (min-width: ${theme.sz.md}) {
      margin: ${theme.sz.s0} ${theme.sz.s3} ${theme.sz.s8};
    }
  `,
);

export const ImageWrapper = styled.div(
  ({ theme }) => css`
    position: relative;
    width: 300px;
    height: ${theme.sz.s24};
    border: ${theme.bo.thinWidth} solid ${theme.co.secondary60};
    box-sizing: border-box;
    box-shadow: ${theme.sz.s0} ${theme.sz.s1} ${theme.sz.s0} ${theme.co.secondary90};
    border-radius: ${theme.sz.s3};
    color: ${theme.co.secondary20};
    background-image: url(${CardBackground});
    background-repeat: no-repeat;
    background-position: bottom center;
    padding: ${theme.sz.s4} ${theme.sz.s3} ${theme.sz.s4} ${theme.sz.s6};
    font-weight: ${theme.DEPRECATED_ty.bold};

    &:active {
      box-shadow: none;
    }

    img {
      width: ${theme.DEPRECATED_ty.mediumLarge};
      height: ${theme.DEPRECATED_ty.mediumLarge};
    }
  `,
);

export const TopWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    margin-bottom: ${theme.sz.s1};
    padding-bottom: ${theme.sz.s4};
    border-bottom: ${theme.bo.thinWidth} solid ${theme.co.secondary20};
  `,
);

export const Title = styled.h3<{ $icon?: string }>(
  ({ theme, $icon }) => css`
    margin: ${theme.sz.s0} ${theme.sz.s0} ${theme.sz.s0} ${theme.sz.s1};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    ${theme.typography.heading.mobile.xs}

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.xs}
    }

    ${
      $icon &&
      css`
        padding-left: ${theme.sz.s6};

        &:before {
          display: inline-block;
          content: '';
          background: url(${$icon}) left center no-repeat;
          background-size: contain;
          position: absolute;
          width: 18px;
          height: 100%;
          left: 0;
        }

        @media (min-width: ${theme.sz.md}) {
          &:before {
            width: ${theme.sz.s5};
          }
        }
      `
    }
  `,
);

export const BottomWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    ${theme.typography.paragraph.s}

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.xxxs}
    }
  `,
);
